//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BCard, BCardBody } from "bootstrap-vue";
import { Icon } from "@iconify/vue2";

export default {
  name: "CoursePausedFloatingCard",
  components: { BCard, BCardBody, Icon },
  props: {
    img: String,
    imgAlt: String,
    shortName: String,
    language: String,
    level: String,
    duration: String,
    graduationCertificate: Boolean,
  },
};
